import React from 'react'
import { Route, Switch } from 'react-router-dom'
import Router from 'shared/universal-router'
import * as blUrls from 'lib/urls'
import DueDateForm from '../components/due-date-form'
import DueDateView from '../components/due-date-view'

interface DueDateCalculatorAppProps {
  emailUrls: string[]
  path: string
}

const DueDateCalculatorApp = ({
  emailUrls,
  path,
}: DueDateCalculatorAppProps) => (
  // @ts-ignore
  <Router location={{ pathname: path }}>
    <Route
      render={({ location }) => (
        <Switch location={location}>
          <Route
            exact
            component={DueDateForm}
            path={blUrls.dueDateCalculatorPath}
          />
          <Route
            path={`${blUrls.dueDateCalculatorPath}/:dueDate`}
            render={(routerProps) => (
              <DueDateView {...routerProps} emailUrls={emailUrls} />
            )}
          />
        </Switch>
      )}
    />
  </Router>
)

export default DueDateCalculatorApp
